import { SplitPane, Splitter } from "@components/Splitter/Splitter";
import useSplitter from "@features/analysis/hooks/useSplitter";
import { ChartType } from "@features/analysis/types/chartType";
import useAppStore from "@hooks/useAppStore";
import { Box } from "@mui/material";
import { Emitter, EventType } from "mitt";
import { observer } from "mobx-react";
import { useRef } from "react";
import useResizeObserver from "use-resize-observer";
import SankeyChart from "../SankeyChart/SankeyChart";
import ByTotalCO2eBarChart from "./ByTotalCO2eBarChart";
import ByTotalCO2eDataGrid from "./ByTotalCO2eDataGrid";

export interface ByTotalCO2eResultsProps {
  emitter: Emitter<Record<EventType, unknown>>;
  chartType: ChartType;
}

const ByTotalCO2eResults = observer((props: ByTotalCO2eResultsProps) => {
  const appStore = useAppStore();
  const containerRef = useRef(null);
  const chartRef = useRef(null);
  const { width: chartWidth, height: chartHeight } = useResizeObserver({ ref: chartRef });
  const { sizes, setSizes } = useSplitter();

  return (
    <Box ref={containerRef} sx={{ display: "flex", flexGrow: 1, flexShrink: 0, height: "100%", minWidth: 0 }}>
      <Splitter onDragEnd={(e: any) => setSizes(e)} minSize={0} sizes={sizes} style={{ display: "flex", flexDirection: "row", flexGrow: 1 }}>
        <SplitPane key={"pane1"} style={{ minWidth: 0 }}>
          {appStore.showChart && (
            <Box ref={chartRef} sx={{ display: "flex", position: "relative", flexGrow: 1, height: "100%" }}>
              <ByTotalCO2eBarChart width={chartWidth} height={chartHeight} emitter={props.emitter} />
            </Box>
          )}
          {appStore.showSankey && (
            <Box ref={chartRef} sx={{ display: "flex", position: "relative", flexGrow: 1, height: "100%" }}>
              <SankeyChart width={chartWidth} height={chartHeight} options={appStore.sankeyOptions} emitter={props.emitter} />
            </Box>
          )}
        </SplitPane>
        <SplitPane key={"pane2"} style={{ position: "relative", minWidth: 0 }}>
          {appStore.showGrid && (
            <Box sx={{ display: "flex", flexGrow: 1, flexShrink: 0, position: "relative", height: "100%", width: "100%" }}>
              <ByTotalCO2eDataGrid emitter={props.emitter} />
            </Box>
          )}
        </SplitPane>
      </Splitter>
    </Box>
  );
});

export default ByTotalCO2eResults;
